import React from 'react';
import { useGlobalUser } from '@sparknz/journeys-common';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { WearableEligibilityCheckSteps } from 'journey/productDetails/typings';
import { useIdentity } from 'shared/hooks';
import { getWearableCheckEligibilitySection } from 'shared/utils';
import { useWearableDevice } from '../../../../hooks';
import AuthenticatedWearableEligibilityCheckButton from './AuthenticatedWearableEligibilityCheckButton';
import UnauthenticatedWearableEligibilityCheckButton from './UnauthenticatedWearableEligibilityCheckButton';

interface WearableEligibilityCheckButtonProps {
  disabled: boolean;
}

export default function WearableEligibilityCheckButton({
  disabled,
}: WearableEligibilityCheckButtonProps) {
  const { isGuest, isLoggedIn, refetchAccountList, refetchLoginStatus } =
    useIdentity();
  const { dispatch, wearableEligibility } = useProductDetails();
  const { isBrandMatch: isSamsungWearable } = useWearableDevice('Samsung');
  const { refetchUser } = useGlobalUser();

  function setActiveWearableCheckStep(step: WearableEligibilityCheckSteps) {
    dispatch({
      type: ProductDetailsActionTypes.SetWearableEligibility,
      wearableEligibility: {
        activeStep: step,
        sections: getWearableCheckEligibilitySection({
          isSamsungWearable,
          wearableEligibility,
        }),
      },
    });
  }

  if (isLoggedIn && !isGuest) {
    return (
      <AuthenticatedWearableEligibilityCheckButton
        setActiveWearableCheckStep={setActiveWearableCheckStep}
        disabled={disabled}
      />
    );
  }

  return (
    <UnauthenticatedWearableEligibilityCheckButton
      setActiveWearableCheckStep={setActiveWearableCheckStep}
      refetchUser={refetchUser}
      refetchAccountList={refetchAccountList}
      refetchLoginStatus={refetchLoginStatus}
      disabled={disabled}
    />
  );
}
